import React, { Component } from "react";

export default class BitmovinPlayer extends Component {
  shouldComponentUpdate() {
    return false;
  }

  divMounted(el) {
    if (el == null) {
      return;
    }

    const conf = {
      key: "4ed98762-1923-4448-8f61-66a99ed0bf3b",
      source: {
        hls: this.props.manifestURL
      }
    };
    const player = window.bitmovin.player("bitmovin-div");

    player.setup(conf).then(() => {
      player.addEventHandler("onTimeChanged", () => {
        this.props.timeUpdateCallback(player.getCurrentTime() * 1000);
      });
    });
  }

  render() {
    return (
      <div
        id="bitmovin-div"
        style={{ width: "100%" }}
        ref={this.divMounted.bind(this)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/VOD/Players/Bitmovin.js